import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Payment = () => {
    document.title = "Ödəniş";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ayarlar", value: "/settings" },
        { name: "Ödəniş", value: "/settings/payment", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <h2 className="my-4">Ödəniş</h2>
                <div className="row g-4">
                    <div className="col-12">
                        <Link to={"million"}>Milli Ön</Link>
                    </div>
                    <div className="col-12">
                        <Link to={"emanat"}>E-Manat</Link>
                    </div>
                    <div className="col-12">
                        <Link to={"inprogram"}>Proqram daxili</Link>
                    </div>
                    <div className="col-12">
                        <Link to={"history"}>Ödəniş tarixçəsi</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};
